import {
  FormLabel,
  Grid,
  OutlinedInput,
  alpha,
  styled,
  useTheme,
} from "@mui/material";
import { Wrapper } from "../layout/Wrapper";
import { Container, Box, Stack, Typography, Button } from "@mui/material";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import { PUBLIC_KEY, SERVICE_ID, TEMPLATE_ID } from "../utils/config";

const FormGrid = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignContent: "center",
}));

const GetQuote = ({ mode, toggleColorMode }) => {
  const theme = useTheme();

  const form = useRef();

  const resetForm = () => {
    form.current.reset();
  };
  const sendEmail = async (e) => {
    e.preventDefault();
    try {
      const response = await emailjs.sendForm(
        SERVICE_ID,
        TEMPLATE_ID,
        form.current,
        {
          publicKey: PUBLIC_KEY,
        }
      );
      console.log(response.status);
      response.status === 200
        ? toast.success("Message sent!")
        : toast.error("Unable to sent message, Please try again");
      resetForm();
    } catch (error) {
      console.error("FAILED...", error);
    }
  };

  return (
    <Wrapper mode={mode} toggleColorMode={toggleColorMode}>
      <Box
        id="getQuote"
        sx={(theme) => ({
          width: "100%",
          background:
            theme.palette.mode === "light"
              ? // ? "linear-gradient(180deg, #CEE5FD, #FFF)"
                "#f6f4fa"
              : `linear-gradient(#02294F, ${alpha("#090E10", 0.0)})`,
          backgroundSize: "100% 20%",
          backgroundRepeat: "no-repeat",
        })}
      >
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: { xs: 14, sm: 20 },
            pb: { xs: 7, sm: 18 },
          }}
        >
          <Stack
            spacing={1}
            useFlexGap
            sx={{ width: { xs: "100%", sm: "70%" } }}
          >
            <Typography
              component="div"
              variant="body1"
              textAlign="center"
              sx={{
                color:
                  theme.palette.mode === "light"
                    ? theme.palette.secondary.main
                    : "#9043c6",
                fontWeight: "bold",
              }}
            >
              LETS START A PROJECT TOGETHER
            </Typography>
            <Typography
              component="h2"
              variant="h4"
              color="text.primary"
              fontWeight="bold"
              textAlign="center"
              sx={{ lineHeight: { xs: "2.5rem" }, mt: 4, mb: 4 }}
            >
              Get A Quote
            </Typography>
            <Typography
              textAlign="center"
              color="text.secondary"
              sx={{
                alignSelf: "center",
                pb: 5,
                width: { sm: "100%", md: "80%" },
              }}
            >
              Get in touch with our team and receive a free project quote
              tailored to your unique vision.
            </Typography>
            <Typography data-aos="fade-up" data-aos-duration="1000">
              <form ref={form} onSubmit={sendEmail}>
                <Grid container spacing={3}>
                  <FormGrid item xs={12} md={6}>
                    <FormLabel required>First name</FormLabel>
                    <OutlinedInput
                      name="user_fname"
                      type="text"
                      placeholder="John"
                      autoComplete="first name"
                      required
                    />
                  </FormGrid>
                  <FormGrid item xs={12} md={6}>
                    <FormLabel required>Last name</FormLabel>
                    <OutlinedInput
                      id="last-name"
                      name="user_lname"
                      type="text"
                      placeholder="Snow"
                      autoComplete="last name"
                      required
                    />
                  </FormGrid>
                  <FormGrid item xs={12}>
                    <FormLabel required>Email</FormLabel>
                    <OutlinedInput
                      id="email"
                      name="user_email"
                      type="email"
                      placeholder="youremail@email.com"
                      autoComplete="Email"
                      required
                    />
                  </FormGrid>
                  <FormGrid item xs={12}>
                    <FormLabel>Phone</FormLabel>
                    <OutlinedInput
                      id="phone"
                      name="user_phone"
                      type="number"
                      placeholder="02354636"
                    />
                  </FormGrid>
                  <FormGrid item xs={12}>
                    <FormLabel>Business Name</FormLabel>
                    <OutlinedInput
                      id="business-name"
                      name="user_businessName"
                      type="text"
                      placeholder="Your business Name"
                      autoComplete="business-name"
                    />
                  </FormGrid>
                  <FormGrid item xs={12}>
                    <FormLabel required>Description</FormLabel>
                    <OutlinedInput
                      id="description"
                      name="message"
                      type="text"
                      placeholder="Tell us about what you want to do!"
                      multiline
                      rows={4}
                      required
                    />
                  </FormGrid>
                </Grid>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  alignSelf="center"
                  useFlexGap
                  sx={{
                    pt: 2,
                    mt: 4,
                    width: { xs: "100%", sm: "100%" },
                    justifyContent: { sm: "flex-end" },
                  }}
                >
                  <Button
                    variant="contained"
                    size="large"
                    type="submit"
                    color="primary"
                  >
                    Send
                  </Button>
                </Stack>
              </form>
            </Typography>
          </Stack>
        </Container>
      </Box>
    </Wrapper>
  );
};

export default GetQuote;
